import colors from "../styles/colors/colors";
import fontWeight from "../styles/mui/fontWeight";
import { DEFAULT_PAGE, PER_PAGE } from "./FunctionalUtils";
import {
  Headcell100,
  Headcell130,
  Headcell150,
  Headcell170,
  Headcell200,
  Headcell250,
  Headcell40,
  Headcell80,
} from "./style";

export const RationalTemplateFormDetails = {
  title: "The following resources were utilized in the decision to deny services:",
  medicaid: "Medicaid rationale:",
  othermedicaid: "Other Medicaid rationale:",
};

export enum DisciplineData {
  ACTION = "ACTION",
  APPROVED_VISITS = "APPROVED VISITS",
  ASSIGNED_TO = "ASSIGNED TO",
  DATE_TIME_REQUEST_RECEIVED = "DATE/TIME REQUEST RECEIVED",
  DENIED_VISITS = "DENIED VISITS",
  EFFECTIVE_END_DATE = "EFFECTIVE END DATE",
  EFFECTIVE_START_DATE = "EFFECTIVE START DATE",
  PROCEDURE_CODE = "PROCEDURE CODE",
  REQUESTED_VISITS = "REQUESTED VISITS",
  SERVICE_NO = "SERVICE NO.",
  STATUS = "STATUS",
  STATUS_REASON = "STATUS REASON",
  TYPE = "TYPE",
  URGENCY = "URGENCY",
  SKILL = "SKILL",
  SERVICE_REQ_NO = "SERVICE REQ. NO.",
}

export const DisciplineHeaderLabel = [
  {
    label: DisciplineData.DATE_TIME_REQUEST_RECEIVED,
    style: { cell: Headcell250 },
  },
  { label: DisciplineData.TYPE, style: { cell: Headcell80 } },
  { label: DisciplineData.URGENCY, style: { cell: Headcell80 } },
  { label: DisciplineData.SKILL, style: { cell: Headcell40 } },
  { label: DisciplineData.EFFECTIVE_START_DATE, style: { cell: Headcell170 } },
  { label: DisciplineData.EFFECTIVE_END_DATE, style: { cell: Headcell170 } },
  { label: DisciplineData.REQUESTED_VISITS, style: { cell: Headcell150 } },
  { label: DisciplineData.APPROVED_VISITS, style: { cell: Headcell130 } },
  { label: DisciplineData.DENIED_VISITS, style: { cell: Headcell100 } },
  { label: DisciplineData.STATUS, style: { cell: Headcell100 } },
  { label: DisciplineData.STATUS_REASON, style: { cell: Headcell200 } },
  { label: DisciplineData.ACTION, style: { cell: Headcell80 } },
];

export const disciplineList = [
  {
    value: "dateTimeRequestReceived",
    fontWeight: fontWeight.Weight[4],
    color: colors.black[15],
  },
  {
    value: "type",
    fontWeight: fontWeight.Weight[6],
    color: colors.black[15],
  },
  {
    value: "urgency",
    fontWeight: fontWeight.Weight[4],
    color: colors.black[15],
  },
  {
    value: "skill",
    fontWeight: fontWeight.Weight[3],
    color: colors.fonts[4],
  },
  {
    value: "effectiveStartDate",
    fontWeight: fontWeight.Weight[3],
    color: colors.fonts[4],
  },
  {
    value: "effectiveEndDate",
    fontWeight: fontWeight.Weight[3],
    color: colors.fonts[4],
  },
  {
    value: "requestedVisits",
    fontWeight: fontWeight.Weight[4],
    color: colors.black[4],
  },
  {
    value: "approvedVisits",
    fontWeight: fontWeight.Weight[4],
    color: colors.black[4],
  },
  {
    value: "deniedVisits",
    fontWeight: fontWeight.Weight[4],
    color: colors.black[4],
  },
  {
    value: "status",
    fontWeight: fontWeight.Weight[6],
    color: colors.black[15],
  },
  {
    value: "statusReason",
    fontWeight: fontWeight.Weight[5],
    color: colors.black[15],
  },
];

export enum ServiceStatus {
  APPROVED = "Approved",
  CANCELLED = "Cancel",
  DENIED = "Denied",
  EXPEDITED = "Expedited",
  PARTIALLY_APPROVED = "Partially Approved",
  PENDING = "Pending",
  STANDARD = "Standard",
}

export enum UrgencyStatus {
  EXPEDITED = "Expedited",
  STANDARD = "Standard",
}

export const DisciplineRecord = {
  referralId: -1,
  serviceRequestId: -1,
  serviceRequestDisciplineId: -1,
  serviceRequestTypeId: -1,
  serviceRequestTypeName: "",
  urgencyId: 0,
  urgencyStatus: "",
  serviceNumber: -1,
  serviceRequestNumber: "",
  requestDateTime: "",
  effectiveFromDate: "",
  effectiveThroughDate: "",
  requestedVisits: -1,
  approvedVisits: -1,
  deniedVisits: -1,
  serviceStatus: "",
  serviceStatusId: 0,
  serviceStatusReason: "",
  skill: "",
  assignedUserId: 0,
  assignedUserFullName: "",
  decisionDateTime: "",
  highestCred: null,
  isRetro: false,
}

export const DefaultPaginationData = {
  pageNo: DEFAULT_PAGE,
  pageSize: PER_PAGE,
};

export enum DisciplineActionDispatchTypes {
  DISCIPLINE_INVOKE = "DISCIPLINE_INVOKE",
  DISCIPLINE_SUCCESS = "DISCIPLINE_SUCCESS",
  DISCIPLINE_RESET = "DISCIPLINE_RESET",
}

export enum DisciplineDetailsActionDispatchTypes {
  GET_DISCIPLINE_DETAILS_ERROR = "GET_DISCIPLINE_DETAILS_ERROR",
  GET_DISCIPLINE_DETAILS_INVOKE = "GET_DISCIPLINE_DETAILS_INVOKE",
  GET_DISCIPLINE_DETAILS_SUCCESS = "GET_DISCIPLINE_DETAILS_SUCCESS",
  GET_DISCIPLINE_DETAILS_RESET = "GET_DISCIPLINE_DETAILS_RESET",
}
